import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Collapse, Divider, Tag, Alert, Typography, Tabs, Table, Button } from 'antd'
import { Chart, Interval, Tooltip, Axis, Coordinate } from 'bizcharts'
import { req_single_cms_learnmap_ucan_holland, req_single_cms_learnmap_ucan_holland_details, req_single_ucan_token_get } from '../../api'
import './coursemap-student-ucan-holland.css'
import { ORG_CODE } from '../../utils/contrains'


const { TabPane } = Tabs
const { Panel } = Collapse
const { Title } = Typography
class CoursemapStudentUcanholland extends Component {
    // 基礎通用參數 //////////////////////////////////////////////  
    state = {
        items: [],
        deviceWidth: 0,
        loading: false,
        defaultDate: '',
        details: [],
        chartdata: [],
        ssourl: null
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize.bind(this))
        this.resize()
        this.api_init_items()
        this.ucan_sso_process()
    }

    // componentWillUnmount() {
    //     window.removeEventListener("resize", this.resize.bind(this))
    // }

    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_init_items = async () => {
        const { userCode, token } = this.props.user

        this.setState({ loading: true, items: [] })
        const result = await req_single_cms_learnmap_ucan_holland(userCode, token)

        if (result.total > 0) {
            //console.log(result.data);
            const items = result.data;
            const { finished_date } = items[0]
            this.setState({ items, defaultDate: finished_date })
            this.tab_change(finished_date)
        } else {
            this.setState({ loading: false })
        }
    }

    // 數據格式處理 //////////////////////////////////////////////
    ucan_sso_process = async () => {
        const originalUrl = "https://ucan.moe.edu.tw/search/discover.aspx"
        const { userCode } = this.props.user
        const key = ORG_CODE + userCode.replace(/\s+/g, '').toUpperCase()
        const token = await req_single_ucan_token_get(ORG_CODE, key)
        //console.log('token',token)
        const ssourl = token === 'NA' ? originalUrl : 'https://ucan.moe.edu.tw/bin/index.php?Plugin=o_hdu&Action=ohduschoolssologin&username=' + key + '&school=' + ORG_CODE + '&token=' + token
        this.setState({ ssourl })
    }

    // 介面互動處理 //////////////////////////////////////////////

    tab_change = async (key) => {
        this.setState({ details: [], chartdata: [] })
        const { userCode, token } = this.props.user
        const chart = await req_single_cms_learnmap_ucan_holland_details(userCode, key, token)
        if (chart && chart.total > 0) {
            // console.log(ans.data);
            const details = chart.data
            const chartdata = []
            details.forEach((d, idx) => {
                const name = d.hType + '(' + d.hCode + ')'
                chartdata.push({ label: name, 原始值: d.score, 全國PR: d.pr })
            })
            this.setState({ details, chartdata })
        }
        this.setState({ loading: false })
    }

    /////////////////////////////////////////////////////////////    
    render() {
        const { loading, deviceWidth, items, defaultDate, details, chartdata, ssourl } = this.state
        // 沒數據
        const descriptionNonedata = (<>
            <div>
                <Title level={2}><Alert message="關於6種人格興趣相關說明" type="success" /></Title>
            </div>
            <div className="row" >
                <div className="col-sm col-md-4" >
                    <Collapse accordion>
                        <Panel header="藝術型（A）" key="1">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>複雜、想像、衝動、獨立、直覺、無秩序、情緒化、理想化、不順從、有創意、有表情、不重實際</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛藝術性的職業或情境，避免傳統型的職業或情境</span>
                                </li>
                                <li>
                                    <span>以藝術方面的能力解決工作或其他方面的問題，自覺富有表達能力、創造能力，擁有藝術與音樂方面的能力（包括表演、寫作、語言）</span>
                                </li>
                                <li>
                                    <span>重視審美價值與美感經驗</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>詩人、小說家、音樂家、畫家、舞台導演、室內設計師、美術設計人員</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>藝術型環境需要工作者以感性、想像及品味去創作及鑑賞藝術作品。其中最簡單者需要有美感，最複雜者需要有想像力並對模糊不明確的情境有絕大的容忍力。此類環境需要工作者將自己知識、直覺及感情作整體統合以解決環境中問題</span>
                        </Panel>
                    </Collapse>
                </div>
                <div className="col-sm col-md-4" >
                    <Collapse accordion>
                        <Panel header="企業型（E）" key="3">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>冒險、野心、獨斷、衝動、樂觀、自信、追求享樂、精力充沛、善於社交、獲取注意、知名度</span>
                            <Divider orientation="left" plain></Divider>
                            <Title level={1}><Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag></Title>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛企業性質的職業或情境，而避免研究性的職業或情境，並以企業方面的能力解決工作及其他方面的問題</span>
                                </li>
                                <li>
                                    <span>自覺有衝動、自信、善社交、知名度高、有領導與語言能力、缺乏科學能力，但重視政治與經濟上的成就</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>推銷員、政治家、企業經理、律師、電視製作人員、業務人員</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>企業行環境中需要工作者有語文能力，以說服或影響他人。此類.環境大多是政治機構如房地產公司、廣告公司、商業機構及貿易公司</span>
                            <Divider orientation="left" plain></Divider>
                        </Panel>
                    </Collapse>
                </div>
                <div className="col-sm col-md-4" >
                    <Collapse accordion>
                        <Panel header="實用型（R）" key="5">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>順從、坦率、謙虛、自然、堅毅、實際、有禮、穩健、節儉</span>
                            <Divider orientation="left" plain></Divider>
                            <Title level={1}><Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag></Title>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛實用性的職業或情境，以從事所喜好的活動，避免社會性的職業或情境</span>
                                </li>
                                <li>
                                    <span>以具體實際的能力解決工作及其他方面的問題，較缺乏人際關係方面的能力</span>
                                </li>
                                <li>
                                    <span>重視具體的事物或個人明確的特性，如金錢、權力或地位等</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>一般勞工、工匠、農夫、機械師、線上操作員</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>實用型環境的工作大多明確，（編註：二十世紀時）多在戶外進行，一般需要機械能力、耐力及體力。在此類型的環境生活及工作，並不太需要社交能力，工作的性質也通常是一系列簡單的動作，並且需要明顯而立即地判斷「成功」及「失敗」。這些環境一般包括機械工廠、農場、營造廠、加油站或理髮店等</span>
                            <Divider orientation="left" plain></Divider>
                        </Panel>
                    </Collapse>
                </div>
            </div>
            {deviceWidth > 800 ? (<p />) : ''}
            <div className="row" >
                <div className="col-sm col-md-4" >
                    <Collapse accordion>
                        <Panel header="資料型（C）" key="2">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>順從、謹慎、保守、自抑、服從、規律、堅毅、實際穩重、有效率、缺乏想像力</span>
                            <Divider orientation="left" plain></Divider>
                            <Title level={1}><Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag></Title>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛傳統性質的職業或情境，而避免藝術性的職業或情境，並以傳統的能力解決工作及其他方面的問題</span>
                                </li>
                                <li>
                                    <span>具有文書作業與數字計算的能力並重視商業與經濟上的成就</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>出納員、會計人員、銀行行員、行政助理、秘書、文書處理人員</span>
                            <span></span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>事務型環境中的工作需要工作者有系統、具體及例行的程序去處理語文和數學的訊息。一般而言，工作的成果相當容易在短期內觀察得到。較複雜的工作包括管理他人，或指揮整個生產運作系統，例如：擔任銀行督導、銀行出納及成本估計。這種環境包含的工作多半不需要時間來完成、有一定的規則、內容重複、具體而有組織；工作時一般需要伸手握拿、觸摸及目視等省力的動作</span>
                            <Divider orientation="left" plain></Divider>
                        </Panel>
                    </Collapse>
                </div>
                <div className="col-sm col-md-4" >
                    <Collapse accordion>
                        <Panel header="研究型（I）" key="4">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>分析、謹慎、批評、好奇、獨立、聰明、內向、條理、謙遜、精確、理性、保守</span>
                            <Divider orientation="left" plain></Divider>
                            <Title level={1}><Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag></Title>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛研究性性質的職業或情境，避免企業型的職業或情境</span>
                                </li>
                                <li>
                                    <span>以研究的能力解決工作及其他方面的問題，亦即自覺自己好學、有自信、重視科學，但缺乏領導方面的才能</span>
                                </li>
                                <li>
                                    <span>重視科學價值，擁有科學和學方面的能力，但缺乏領導才能</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>研發工程師、化學師、數學師、科學家、研究學者</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>研究型環境的工作大多需要抽象思考及創造力完成，而不太需要個人的主觀意見、理解力及敏感度。成就是漸進長期的；但有一套客觀的方法來測量工作成果。在此環境中，工作的難度有相當大的差異，有些只要直接訓練即可，有些則需要耐心及創意才能解決問題</span>
                            <Divider orientation="left" plain></Divider>
                        </Panel>
                    </Collapse>
                </div>
                <div className="col-sm col-md-4" >
                    <Collapse accordion>
                        <Panel header="社會型（S）" key="6">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>合作、友善、慷慨、助人、仁慈、負責、圓滑、善社交、善解人意、說服他人、理想主義、富洞察力</span>
                            <Divider orientation="left" plain></Divider>
                            <Title level={1}><Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag></Title>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛社會性的職業或情境，而避免實用性的職業或情境，並以社交方面的能力解決工作及其他方面的問題</span>
                                </li>
                                <li>
                                    <span>自覺喜歡幫助別人、了解別人、有教導別人的能力，且重視社會與倫理的活動與問題</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>中小學教師、傳教士、輔導人員、社會工作者、心理顧問、護理人員</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>社會型環境中的工作需要有了解及改正人類行為的能力，並有關懷他人及與人溝通的興趣。一般而言，此類環境常會增加工作者的自尊</span>
                            <Divider orientation="left" plain></Divider>
                        </Panel>
                    </Collapse>
                </div>
            </div>
        </>)
        const originalUrl = ssourl
        const notest = (<div className="alert alert-danger" role="alert"><a href={originalUrl} target="_blank" className="btn btn-mdanger" rel="noreferrer" role="button"><Button type="primary" shape="round" size="small"> 按我 <i className="fas fa-mouse-pointer" style={{ marginLeft: '4px' }}></i></Button> 測測你的人格特質 (註：今日測驗/明日解析)</a></div>)
        // 有數據
        const descriptionHasdata = (<div>
            <div>
                <Title level={2}><Alert message="關於6種人格興趣相關說明" type="success" /></Title>
            </div>
            <div className="row" >
                <div className="col-sm col-md" >
                    <Collapse accordion >
                        <Panel header="企業型（E）" key="3">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>冒險、野心、獨斷、衝動、樂觀、自信、追求享樂、精力充沛、善於社交、獲取注意、知名度</span>
                            <Divider orientation="left" plain></Divider>
                            <Title level={1}><Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag></Title>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛企業性質的職業或情境，而避免研究性的職業或情境，並以企業方面的能力解決工作及其他方面的問題</span>
                                </li>
                                <li>
                                    <span>自覺有衝動、自信、善社交、知名度高、有領導與語言能力、缺乏科學能力，但重視政治與經濟上的成就</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>推銷員、政治家、企業經理、律師、電視製作人員、業務人員</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>企業行環境中需要工作者有語文能力，以說服或影響他人。此類.環境大多是政治機構如房地產公司、廣告公司、商業機構及貿易公司</span>
                            <Divider orientation="left" plain></Divider>
                        </Panel>
                        <Panel header="實用型（R）" key="5">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>順從、坦率、謙虛、自然、堅毅、實際、有禮、穩健、節儉</span>
                            <Divider orientation="left" plain></Divider>
                            <Title level={1}><Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag></Title>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛實用性的職業或情境，以從事所喜好的活動，避免社會性的職業或情境</span>
                                </li>
                                <li>
                                    <span>以具體實際的能力解決工作及其他方面的問題，較缺乏人際關係方面的能力</span>
                                </li>
                                <li>
                                    <span>重視具體的事物或個人明確的特性，如金錢、權力或地位等</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>一般勞工、工匠、農夫、機械師、線上操作員</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>實用型環境的工作大多明確，（編註：二十世紀時）多在戶外進行，一般需要機械能力、耐力及體力。在此類型的環境生活及工作，並不太需要社交能力，工作的性質也通常是一系列簡單的動作，並且需要明顯而立即地判斷「成功」及「失敗」。這些環境一般包括機械工廠、農場、營造廠、加油站或理髮店等</span>
                            <Divider orientation="left" plain></Divider>
                        </Panel>
                        <Panel header="藝術型（A）" key="1">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>複雜、想像、衝動、獨立、直覺、無秩序、情緒化、理想化、不順從、有創意、有表情、不重實際</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛藝術性的職業或情境，避免傳統型的職業或情境</span>
                                </li>
                                <li>
                                    <span>以藝術方面的能力解決工作或其他方面的問題，自覺富有表達能力、創造能力，擁有藝術與音樂方面的能力（包括表演、寫作、語言）</span>
                                </li>
                                <li>
                                    <span>重視審美價值與美感經驗</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>詩人、小說家、音樂家、畫家、舞台導演、室內設計師、美術設計人員</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>藝術型環境需要工作者以感性、想像及品味去創作及鑑賞藝術作品。其中最簡單者需要有美感，最複雜者需要有想像力並對模糊不明確的情境有絕大的容忍力。此類環境需要工作者將自己知識、直覺及感情作整體統合以解決環境中問題</span>
                        </Panel>
                        <Panel header="資料型（C）" key="2">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>順從、謹慎、保守、自抑、服從、規律、堅毅、實際穩重、有效率、缺乏想像力</span>
                            <Divider orientation="left" plain></Divider>
                            <Title level={1}><Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag></Title>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛傳統性質的職業或情境，而避免藝術性的職業或情境，並以傳統的能力解決工作及其他方面的問題</span>
                                </li>
                                <li>
                                    <span>具有文書作業與數字計算的能力並重視商業與經濟上的成就</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>出納員、會計人員、銀行行員、行政助理、秘書、文書處理人員</span>
                            <span></span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>事務型環境中的工作需要工作者有系統、具體及例行的程序去處理語文和數學的訊息。一般而言，工作的成果相當容易在短期內觀察得到。較複雜的工作包括管理他人，或指揮整個生產運作系統，例如：擔任銀行督導、銀行出納及成本估計。這種環境包含的工作多半不需要時間來完成、有一定的規則、內容重複、具體而有組織；工作時一般需要伸手握拿、觸摸及目視等省力的動作</span>
                            <Divider orientation="left" plain></Divider>
                        </Panel>
                        <Panel header="研究型（I）" key="4">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>分析、謹慎、批評、好奇、獨立、聰明、內向、條理、謙遜、精確、理性、保守</span>
                            <Divider orientation="left" plain></Divider>
                            <Title level={1}><Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag></Title>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛研究性性質的職業或情境，避免企業型的職業或情境</span>
                                </li>
                                <li>
                                    <span>以研究的能力解決工作及其他方面的問題，亦即自覺自己好學、有自信、重視科學，但缺乏領導方面的才能</span>
                                </li>
                                <li>
                                    <span>重視科學價值，擁有科學和學方面的能力，但缺乏領導才能</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>研發工程師、化學師、數學師、科學家、研究學者</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>研究型環境的工作大多需要抽象思考及創造力完成，而不太需要個人的主觀意見、理解力及敏感度。成就是漸進長期的；但有一套客觀的方法來測量工作成果。在此環境中，工作的難度有相當大的差異，有些只要直接訓練即可，有些則需要耐心及創意才能解決問題</span>
                            <Divider orientation="left" plain></Divider>
                        </Panel>
                        <Panel header="社會型（S）" key="6">
                            <Tag color="purple"><i className="fas fa-tag"></i> 人格特徵</Tag>
                            <p></p>
                            <span>合作、友善、慷慨、助人、仁慈、負責、圓滑、善社交、善解人意、說服他人、理想主義、富洞察力</span>
                            <Divider orientation="left" plain></Divider>
                            <Title level={1}><Tag color="purple"><i className="fas fa-tag"></i> 人格傾向</Tag></Title>
                            <p></p>
                            <ul style={{ listStyleType: "decimal", paddingLeft: "10px" }}>
                                <li>
                                    <span>喜愛社會性的職業或情境，而避免實用性的職業或情境，並以社交方面的能力解決工作及其他方面的問題</span>
                                </li>
                                <li>
                                    <span>自覺喜歡幫助別人、了解別人、有教導別人的能力，且重視社會與倫理的活動與問題</span>
                                </li>
                            </ul>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 典型職業</Tag>
                            <p></p>
                            <span>中小學教師、傳教士、輔導人員、社會工作者、心理顧問、護理人員</span>
                            <Divider orientation="left" plain></Divider>
                            <Tag color="purple"><i className="fas fa-tag"></i> 環境類型</Tag>
                            <p></p>
                            <span>社會型環境中的工作需要有了解及改正人類行為的能力，並有關懷他人及與人溝通的興趣。一般而言，此類環境常會增加工作者的自尊</span>
                            <Divider orientation="left" plain></Divider>
                        </Panel>
                    </Collapse>
                </div>
            </div>
        </div>)
        const columns = [
            {
                title: '人格類型',
                width: 80,
                render: (item) => {
                    const { hCode, hType } = item
                    return (
                        <>
                            {hType}({hCode})
                        </>
                    )
                }
            },
            {
                title: '原始值',
                dataIndex: 'score',
                width: 60,
            },
            {
                title: '全國PR值',
                width: 60,
                render: (item) => {
                    const { pr } = item
                    return (
                        <>
                            {pr}%
                        </>
                    )
                }
            },

        ]
        const tableDetails = details.length > 0 ? (<Table columns={columns} dataSource={details} pagination={false} />) : ''
        const tabPanes = items.length > 0 ? items.map((d, idx) => <TabPane tab={d.finished_date} key={d.finished_date}></TabPane>) : ''

        return (
            <>
                {loading ? (<div className='text-center'>
                    <p />
                    <button className="btn " type="button" disabled>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '4px' }}></span>
                        Loading...
                    </button>
                </div>) : (<>
                    {items.length > 0 ? (<>
                        <a className="btn btn-primary" href={originalUrl} target="_blank" rel="noreferrer" >前往UCAN平台測驗 <i className="fas fa-arrow-circle-right"></i> </a>
                        <Tabs defaultActiveKey={defaultDate} onChange={this.tab_change}>
                            {tabPanes}
                        </Tabs>
                        <div className="row">
                            <div className="col-sm col-md-6" >
                                <Chart height={400} data={chartdata} autoFit>
                                    <Coordinate type="polar" innerRadius={0.2} />
                                    <Axis visible={false} />
                                    <Tooltip showTitle={false} />
                                    <Interval
                                        position="label*全國PR"
                                        adjust="stack"
                                        color="label"
                                        element-highlight
                                        style={{
                                            lineWidth: 1,
                                            stroke: '#fff',
                                        }}
                                        label={['label', {
                                            offset: -15,
                                        }]}
                                    />
                                </Chart>
                                <p />
                                {tableDetails}
                            </div>
                            <div className="col-sm col-md-6" >
                                {descriptionHasdata}
                            </div>
                        </div>
                    </>) : (<>
                        {notest}
                        {descriptionNonedata}
                    </>)}
                </>)}
            </>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CoursemapStudentUcanholland)